var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001B53",
    fillRule: "evenodd",
    d: "M18.788 5.024L20 3.722 18.788 2.42 17.754 1.341 16.506 0 15.257 1.341 6.263 10.707 5 12.009 6.263 13.311 15.257 22.677 16.506 24 17.754 22.677 18.788 21.598 20 20.303 18.788 18.994 12.084 12.016z",
    opacity: 0.5,
    transform: "matrix(-1 0 0 1 24 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/forward-arrow.fc5ac0b145b7b78e11598772a03acf66.svg";
export { ForwardRef as ReactComponent };